export default __webpack_public_path__ + "static/media/newFileIcon.5cc5d3a1.svg";